import { useMemo } from 'react'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalContent from 'LuxKit/Modal/ModalContent'
import FlashHotelAboutRoomModalTab from './FlashHotelAboutRoomModalTab'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import OfferPageRoomGallery from 'components/OfferPage/OfferPageRoomGallery'
import type { ImageParams } from 'components/Common/ResponsiveImage'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  min-height: ${rem(200)};
`

const IMAGE_PROPS: ImageParams = {
  mobileWidth: '100vw',
  tabletWidth: '100vw',
  desktopWidth: '400px',
  largeDesktopWidth: '560px',
  quality: 'good',
  fit: 'center',
}

interface Props {
  room: App.PackageRoomType
  packageOptions: Array<App.OfferPackageOptionView>
  onClose?: () => void
  cheapestSelectedOption?: App.OfferPackageOptionView
}

function FlashHotelRoomDetailsModal(props: Props) {
  const {
    room,
    packageOptions,
  } = props

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const packageViews = packageOptionsByRoom.find(option => option.roomId === room.id)?.packageViews
  const pkg = packageViews?.[0].package!

  const mode = useScreenSizeUp('tablet') ? 'default' : 'drawer'

  return (
    <ModalBase mode={mode}>
      <ModalHeader
        title={room.name}
      />
      <ModalBody>
        <div>
          {!!room.images.length && <ImageContainer>
            <OfferPageRoomGallery
              room={room}
              imageParams={IMAGE_PROPS}
            />
          </ImageContainer>}
        </div>
        <ModalContent>
          <FlashHotelAboutRoomModalTab pkg={pkg} />
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  packageOptions: getDurationPackageOptions(state, appState),
}), FlashHotelRoomDetailsModal)
